import React, { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import './Search.css';
//Select Data
import {
  ALL_SUBJECTS,
  DIFFICULTY,
  EDUCATIVE_LEVEL,
  FORMATS,
  GROUP_TYPES,
  OBJECT_TYPE,
  RESOURCE_TYPE
} from '../../data/constants';

import Select from 'react-select';
// Pagination
import ReactPaginate from 'react-paginate';
import FormGroup from 'react-bootstrap/FormGroup';
import FormCheck from 'react-bootstrap/FormCheck';
import FormCheckInput from 'react-bootstrap/FormCheckInput';
import FormCheckLabel from 'react-bootstrap/FormCheckLabel';
import GroupElement from '../group_list_element/GroupElement';
import { Redirect } from 'react-router-dom';
import { urls } from '../router/urls';
import Skeleton from 'react-loading-skeleton';

const Search = () => {
  const [onBusqueda, setOnBusqueda] = useState(false);

  const [datos, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [query, setQuery] = useState('');

  const { t } = useTranslation();

  /* busqueda */

  const [inSearch, setInSearch] = useState(false);
  const [numRes, setNumRes] = useState(0);
  const [numPaginas, setNumPaginas] = useState(0);
  // const [paginaActual, setPaginaActual] = useState(1);

  /*Filtros de busqueda*/
  const [subject, setSubject] = useState([]);
  const [educativeLevel, setEducativeLevel] = useState('');
  const [difficulty, setDifficulty] = useState({});
  const [format, setFormat] = useState({});
  const [resourceType, setResourceType] = useState({});
  const [is_agrupacion, setIsAgrupacion] = useState(false);
  const [group_type, setGroupType] = useState({});

  const subjectOptions = ALL_SUBJECTS.map(subject => ({
    value: subject,
    label: subject
  }));

  const handleSubjectChange = selectedValues => {
    setSubject((selectedValues || []).map(elemento => elemento));
  };

  const handleFormatChange = useCallback(selectedValue => {
    if (!selectedValue) {
      setFormat(undefined);
    } else {
      setFormat(selectedValue.value);
    }
  }, [setFormat]);

  const handleResourceTypeChange = selectedValue => {
    if (!selectedValue) {
      setResourceType(undefined);
    } else {
      setResourceType(selectedValue.value);
    }
  };

  //agrupaciones
  const handleGroupTypeChange = selectedValue => {
    if (selectedValue === null) {
      setGroupType(undefined);
    } else {
      setGroupType(selectedValue.value);
    }
  };

  const handleDifficultyChange = selectedValue => {
    if (selectedValue === null) {
      setDifficulty(undefined);
    } else {
      setDifficulty(selectedValue.value);
    }
  };

  const handleOnChangeEducativeLevel = e => {
    const value = e.target.value;
    if (e.target.checked) {
      setEducativeLevel(educativeLevel + ',' + value);
    } else {
      setEducativeLevel(educativeLevel.replace(',' + value, ''));
    }
  };

  const limpiarFiltros = () => {
    setSearch('');
    setQuery('');
    setSubject([]);
    setEducativeLevel('');
    setDifficulty(undefined);
    setFormat(undefined);
    setResourceType(undefined);
    setIsAgrupacion(false);
    setGroupType(undefined);
    setOnBusqueda(!onBusqueda);
  };

  const getObjectsInitial = useCallback(
    (pag, search, initialFormat, is_group) => {
      let url = urls.url_api + '/api/resource-objects/?';
      let parameters = '';

      if (search.length > 0) {
        parameters += `search_value=${search}&`;
      }

      if (subject.length > 0) {
        let aux = '';
        subject.map((elemento, index) => {
          if (index === subject.length - 1) {
            aux += elemento.value;
          } else {
            aux += elemento.value + ',';
          }
          return null;
        });
        parameters += `knowledge=${aux}&`;
      }

      if (educativeLevel !== undefined && educativeLevel !== '') {
        parameters += `level=${educativeLevel}&`;
      }

      if (difficulty !== undefined && Object.keys(difficulty).length) {
        parameters += `difficulty=${difficulty}&`;
      }

      if (format !== undefined && Object.keys(format).length) {
        parameters += `resource_format=${format}&`;
      } else if (initialFormat) {
        parameters += `resource_format=${initialFormat}&`;
      }

      if (resourceType !== undefined && Object.keys(resourceType).length) {
        parameters += `learning_resource_type=${resourceType}`;
      }

      if (is_group) {
        if (group_type !== undefined && Object.keys(group_type).length) {
          parameters += `is_group=true&group_type=${group_type}`;
        } else {
          parameters += `is_group=true`;
        }
      }

      axios.get(url + parameters + '&page=' + pag).then(response => {
        setNumPaginas(Math.ceil(response.data.count / 10));
        setData(response.data.results);
        setNumRes(response.data.count);
        setInSearch(true);
        setIsAgrupacion(is_group);
      });
    },
    [
      subject,
      educativeLevel,
      difficulty,
      format,
      resourceType,
      group_type,
      setNumPaginas,
      setData,
      setNumRes,
      setInSearch,
      setIsAgrupacion
    ]
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    let query = window.location.search;
    let params = new URLSearchParams(query);
    let initialQuery = params.get('query');
    setSearch(initialQuery);
    setQuery(initialQuery);
    if (params.get('format')) {
      handleFormatChange(FORMATS.find(o => o.value === params.get('format')));
    }
    getObjectsInitial(1, initialQuery, params.get('format'), false);
  }, [getObjectsInitial, setSearch, setQuery, handleFormatChange]);

  const findFilteredObjects = e => {
    e.preventDefault();
    setSearch(search);
    getObjectsSearchFiltered(1);
  };

  const getObjectsSearchFiltered = useCallback(
    pag => {
      let url = urls.url_api + '/api/resource-objects/?';
      let parameters = '';

      if (search.length > 0) {
        parameters += `search_value=${search}&`;
      }

      if (subject.length > 0) {
        let aux = '';
        subject.map((elemento, index) => {
          if (index === subject.length - 1) {
            aux += elemento.value;
          } else {
            aux += elemento.value + ',';
          }
          return null;
        });
        parameters += `knowledge=${aux}&`;
      }

      if (educativeLevel !== undefined && educativeLevel !== '') {
        parameters += `level=${educativeLevel}&`;
      }

      if (difficulty !== undefined && Object.keys(difficulty).length) {
        parameters += `difficulty=${difficulty}&`;
      }

      if (format !== undefined && Object.keys(format).length) {
        parameters += `resource_format=${format}&`;
      }

      if (resourceType !== undefined && Object.keys(resourceType).length) {
        parameters += `learning_resource_type=${resourceType}`;
      }

      if (is_agrupacion) {
        if (group_type !== undefined && Object.keys(group_type).length) {
          parameters += `is_group=true&group_type=${group_type}`;
        } else {
          parameters += `is_group=true`;
        }
      }

      axios.get(url + parameters + '&page=' + pag).then(response => {
        setNumPaginas(Math.ceil(response.data.count / 10));
        setData(response.data.results);
        setNumRes(response.data.count);
        setInSearch(true);
        setQuery(search);
      });
    },
    [
      search,
      subject,
      educativeLevel,
      difficulty,
      format,
      resourceType,
      is_agrupacion,
      group_type,
      setNumPaginas,
      setData,
      setNumRes,
      setInSearch,
      setQuery
    ]
  );

  const updateSearch = e => {
    setSearch(e.target.value);
  };

  const cambioPagina = data => {
    window.scrollTo(0, 0);
    let selected = data.selected;
    getObjectsSearchFiltered(selected + 1);
    window.scrollTo(0, 0);
  };

  const closeFilterMenu = () => {
    let menu = document.querySelector('.close-menu-filters');
    menu.click();
  };

  return (
    <>
      {/* side panel filtros */}

      {onBusqueda ? <Redirect push to={`/${urls.busqueda}/?query=`} /> : ''}

      <div
        className="modal fade modal-backdrop-transparent modal-filtros"
        aria-modal="true"
        style={{ paddingRight: '15px' }}
      >
        <div className="modal-dialog modal-dialog-right modal-md-filtros">
          <div className="modal-content">
            <div className="dropdown-header d-flex justify-content-between align-items-center w-100">
              <h4 className="m-0 text-secondary font-weight-bold py-3 roboto-pwa">
                <i className="fal fa-filter"> </i> {t('landing_filtrar')}
              </h4>
              <button
                type="button"
                className="close text-secondary position-absolute pos-top pos-right p-2 m-1 mr-2 py-3 close-menu-filters"
                data-dismiss="modal"
              >
                <span>
                  <i className="far fa-times"> </i>
                </span>
              </button>
            </div>
            <div className="modal-body p-0">
              <div className="settings-panel">
                <form onSubmit={findFilteredObjects} className="mx-3 mb-4">
                  <div className="demo">
                    {is_agrupacion ? (
                      <div>
                        <label className="form-label">
                          {t('tipo_agrupacion')}
                        </label>

                        <Select
                          onChange={handleGroupTypeChange}
                          options={GROUP_TYPES}
                          value={
                            GROUP_TYPES.find(o => o.value === group_type) || 0
                          }
                          placeholder={t('selecciona')}
                          className="basic-single"
                          isClearable
                        />
                      </div>
                    ) : null}
                  </div>

                  <div className="form-group">
                    <label
                      className="form-label"
                      htmlFor="react-select-2-input"
                    >
                      {t('landing_area_conocimiento')}
                    </label>
                    <Select
                      onChange={handleSubjectChange}
                      options={subjectOptions}
                      value={subject}
                      placeholder={t('selecciona')}
                      isClearable
                      isMulti
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">
                      {t('landing_nivel_educativo')}
                    </label>
                    {EDUCATIVE_LEVEL.map((level, index) => (
                      <FormCheck
                        key={`level-${index}`}
                        className="custom-control custom-checkbox"
                        id={`check-level-${index}`}
                      >
                        <FormCheckInput
                          name={`level.${index}`}
                          value={level.value}
                          onChange={handleOnChangeEducativeLevel}
                          className="custom-control-input"
                          type="checkbox"
                        />
                        <FormCheckLabel className="custom-control-label">
                          {level.label}
                        </FormCheckLabel>
                      </FormCheck>
                    ))}
                  </div>

                  <div className="form-group">
                    <label
                      className="form-label"
                      htmlFor="react-select-2-input"
                    >
                      {t('landing_dificultad')}
                    </label>
                    <Select
                      onChange={handleDifficultyChange}
                      options={DIFFICULTY}
                      value={DIFFICULTY.find(o => o.value === difficulty) || 0}
                      placeholder={t('selecciona')}
                      isClearable
                    />
                  </div>

                  <div className="form-group">
                    <label
                      className="form-label"
                      htmlFor="react-select-2-input"
                    >
                      {t('landing_formatos')}
                    </label>
                    <Select
                      onChange={handleFormatChange}
                      options={FORMATS}
                      value={FORMATS.find(o => o.value === format) || 0}
                      placeholder={t('selecciona')}
                      isClearable
                    />
                  </div>

                  <div className="form-group">
                    <label
                      className="form-label"
                      htmlFor="react-select-2-input"
                    >
                      {t('landing_tipos_recurso')}
                    </label>
                    <Select
                      onChange={handleResourceTypeChange}
                      options={RESOURCE_TYPE}
                      value={
                        RESOURCE_TYPE.find(o => o.value === resourceType) || 0
                      }
                      placeholder={t('selecciona')}
                      isClearable
                    />
                  </div>

                  <div className="demo">
                    <button
                      onClick={() => {
                        limpiarFiltros();
                        closeFilterMenu();
                      }}
                      type="button"
                      className="btn btn-default btn-pills waves-effect waves-themed"
                    >
                      {t('landing_limpiar_filtros')}
                    </button>
                    <button
                      type="submit"
                      onClick={closeFilterMenu}
                      className="btn btn-info btn-pills waves-effect waves-themed"
                    >
                      {t('buscar')}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* formulario de busqueda */}

      <div className="row">
        <div className="form-group col-md-12">
          <form onSubmit={findFilteredObjects}>
            <div className="input-group input-group-lg shadow-1 busqueda-pwa">
              <input
                type="text"
                className="input-form form-control shadow-inset-2"
                id="busqueda"
                aria-label="Escribir más de dos letras"
                placeholder={t('explorar')}
                value={search}
                onChange={updateSearch}
              />
              <div className="input-group-append">
                <button
                  className="btn btn-default waves-effect waves-themed"
                  type="submit"
                  title={t('buscar')}
                >
                  <i className="far fa-search mr-lg-2"> </i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* seleccionar recurso o agrupacion y boton filtro */}

      <div className="row options-between">
        <div className="col-6">
          <div className="demo">
            <FormGroup controlId="levelGroup" className="float-left">
              {OBJECT_TYPE.map((type, index) => (
                <FormCheck
                  key={`object-type-${index}`}
                  className="custom-control custom-radio custom-control-inline demo"
                  id={`check-object-type-${index}`}
                >
                  <FormCheckInput
                    name={`object-type`}
                    defaultValue={type.value}
                    onChange={() =>
                      getObjectsInitial(1, search, false, type.value)
                    }
                    className="custom-control-input"
                    type="radio"
                    defaultChecked={type.is_default}
                  />
                  <FormCheckLabel className="custom-control-label">
                    {t('OBJECT_TYPE_' + type.label.toString())}
                  </FormCheckLabel>
                </FormCheck>
              ))}
            </FormGroup>
          </div>
        </div>
        <div className="col-6">
          <button
            type="button"
            data-toggle="modal"
            data-target=".modal-filtros"
            className="btn-filtrar btn btn-default waves-effect waves-themed float-right"
          >
            <span className="fal fa-filter mr-1"> </span>
            {t('landing_filtrar')}
          </button>
        </div>
      </div>

      {/* informacion de resultados */}
      {inSearch ? (
        <div className="demo row options-between">
          <h3 className="mb-3 work-sans-pwa link-share col-8 float-left">
            {' '}
            {numRes}{' '}
            {query === ''
              ? t('landing_resultados_encontrados') + ' "*"'
              : t('landing_resultados_encontrados') + ' "' + query + '"'}
          </h3>
          <button
            type="button"
            onClick={() => {
              limpiarFiltros();
            }}
            title={t('landing_reiniciar_busqueda')}
            className="btn-filtrar btn btn-default waves-effect waves-themed col-12 col-md-4 float-right"
          >
            <i className="far fa-redo"> </i> {t('landing_reiniciar_busqueda')}
          </button>
        </div>
      ) : (
        ''
      )}

      {/* skeleton antes de la carga */}
      {datos.length === 0 && !inSearch && (
        <div className="mt-6">
          <div className={'row options'}>
            <div className="col-md-3 mb-3">
              <Skeleton height={150} />
            </div>
            <div className="col-md-8">
              <Skeleton count={6} />
            </div>
          </div>

          <div className={'row options'}>
            <div className="col-md-3 mb-3">
              <Skeleton height={150} />
            </div>
            <div className="col-md-8">
              <Skeleton count={6} />
            </div>
          </div>

          <div className={'row options'}>
            <div className="col-md-3 mb-3">
              <Skeleton height={150} />
            </div>
            <div className="col-md-8">
              <Skeleton count={6} />
            </div>
          </div>
        </div>
      )}

      {datos.map((objeto, index) => (
        <GroupElement
          key={index}
          is_group={objeto.group_type}
          img={urls.url_api + objeto.image}
          stars={objeto.average_ranking}
          taxon={''}
          descripcion={objeto.general.description[0].value}
          nombre={objeto.general.title.value}
          format={objeto.technical[0].format.value || ''}
          id={objeto.id}
          structured_group_data={objeto.structured_group_data}
        />
      ))}

      {/* paginacion */}

      {inSearch && numRes > 0 ? (
        <div className="row options-between tab-content">
          <ReactPaginate
            previousLabel={'«'}
            nextLabel={'»'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={numPaginas}
            marginPagesDisplayed={1}
            pageRangeDisplayed={3}
            onPageChange={cambioPagina}
            containerClassName={'pagination my-4'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
            pageLinkClassName={'page-link'}
            pageClassName={'page-item'}
            previousClassName={'page-item'}
            nextClassName={'page-item'}
            previousLinkClassName={'page-link'}
            nextLinkClassName={'page-link'}
          />
        </div>
      ) : (
        ''
      )}

      {inSearch && numRes === 0 ? (
        <div
          className="alert border-info bg-transparent text-info fade show options"
          role="alert"
          style={{ margin: '15px 30px 15px 30px' }}
        >
          <div className="d-flex align-items-center">
            <div className="alert-icon">
              <i className="fal fa-exclamation-triangle"> </i>
            </div>
            <div className="flex-1">
              <span className="h5 m-0 fw-700">
                {t('landing_no_resultados')}
              </span>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default Search;
